import { getContract } from "./core";

export async function getMintStage() {
  const contract = await getContract();
  return (await contract.MINT_STAGE()).toNumber();
}
